import React, { useState } from 'react';
import { Instagram, Mail } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import PolicyModal from './PolicyModal';
import './Footer.css';

export const Footer = () => {
  const currentYear = new Date().getFullYear();
  const { t } = useLanguage();
  const [showPolicy, setShowPolicy] = useState(false);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-brand">
            <h3 className="footer-logo">C. LLAGUNO</h3>
            <p className="footer-tagline">{t('footer_tagline')}</p>
          </div>

          <nav className="footer-nav">
            <button onClick={() => scrollToSection('works')} className="footer-link">
              {t('nav_works')}
            </button>
            <button onClick={() => scrollToSection('sculptures')} className="footer-link">
              {t('nav_sculptures')}
            </button>
            <button onClick={() => scrollToSection('about')} className="footer-link">
              {t('nav_about')}
            </button>
            <button onClick={() => scrollToSection('contact')} className="footer-link">
              {t('nav_contact')}
            </button>
            <button onClick={() => setShowPolicy(true)} className="footer-link" data-testid="footer-policy">
              {t('shipping_returns')}
            </button>
          </nav>

          <div className="footer-social">
            <a 
              href="mailto:carlotatorresll@gmail.com" 
              className="social-link"
              aria-label="Email"
            >
              <Mail size={20} />
            </a>
            <a 
              href="https://instagram.com/ct.llaguno" 
              target="_blank" 
              rel="noopener noreferrer"
              className="social-link"
              aria-label="Instagram"
            >
              <Instagram size={20} />
            </a>
          </div>
        </div>

        <div className="footer-bottom">
          <p className="footer-copyright">
            © {currentYear} C. Llaguno. {t('footer_rights')}
          </p>
        </div>
      </div>

      <PolicyModal isOpen={showPolicy} onClose={() => setShowPolicy(false)} />
    </footer>
  );
};

export default Footer;
